var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FileNameUtils from "../../../../util/fileNameUtils";
import FAIcon from "../FAIcon/FAIcon";
const FileIcon = (_a) => {
    var { extension } = _a, otherProps = __rest(_a, ["extension"]);
    return (_jsx(FAIcon, Object.assign({}, otherProps, { icon: FileNameUtils.getFileIconClass(extension).slice("fa-".length) })));
};
export default FileIcon;
